export interface ToolStatus {
  type: 'running' | 'complete' | 'incomplete' | 'requires-action';
  reason?: string;
}

export function getToolStatusFlags(status?: ToolStatus) {
  return {
    isRunning: status?.type === 'running',
    isComplete: status?.type === 'complete',
    isError: status?.type === 'incomplete' && status?.reason === 'error',
  };
}

export function buildToolStatusFromFlags({
  isRunning,
  hasError,
}: {
  isRunning: boolean;
  hasError: boolean;
}): ToolStatus {
  if (isRunning) return { type: 'running' };
  if (hasError) return { type: 'incomplete', reason: 'error' };
  return { type: 'complete' };
}
